import * as mutationType from "../mutation_types";
import moment from "moment";

const state = {
  overview: {},
  checkin: {},
  history: [],
  tab: 0,
  drawer: false,
  outstanding_action_items: [],
  unfinished: [],
  talking_point: {}
};

const getters = {
  overview: state => state.overview || {},
  list: (state, getters) => getters.overview.checkIns || [],
  checkin: state => state.checkin || {},
  history: state => state.history,
  tab: state => state.tab,
  drawer: state => state.drawer,
  outstanding_action_items: state => state.outstanding_action_items,
  unfinished: state => state.unfinished,
  talking_point: state => state.talking_point
};

const actions = {
  getCheckIns({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/checkins")
        .then(res => {
          commit(mutationType.SET_CHECKINS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCheckInHistory({ commit }, definitionId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/checkins/${definitionId}/history`)
        .then(res => {
          commit(mutationType.SET_CHECKIN_HISTORY, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCheckIn({ commit }, checkin) {
    return new Promise((resolve, reject) => {
      let url = `/api/checkins/${checkin.definitionId}`;
      if (checkin.id) {
        url += `/${checkin.id}`;
      }
      this._vm.$http
        .get(url)
        .then(res => {
          commit(mutationType.SET_CHECKIN, res.data);
          commit(`goal/${mutationType.SET_GOALS}`, res.data.goals, {
            root: true
          });
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveCheckIn({ commit }, checkin) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/checkins`, checkin)
        .then(res => {
          commit(mutationType.SET_CHECKIN, res.data);
          resolve(res.data.definitionId);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  startCheckin({ commit, state }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/checkins/${state.checkin.definitionId}/start`)
        .then(res => {
          commit(mutationType.SET_CHECKIN_START, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  unstartCheckin({ commit, state }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/checkins/${state.checkin.definitionId}/unstart`)
        .then(() => {
          commit(mutationType.SET_CHECKIN_UNSTART);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  completeCheckin({ state }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/checkins/${state.checkin.definitionId}/complete`)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  archiveCheckIn({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/checkins/${id}/archive`)
        .then(() => {
          commit(mutationType.ARCHIVE_CHECKIN, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteCheckIn({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/checkins/${id}`)
        .then(() => {
          commit(mutationType.DELETE_CHECKIN, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  leaveCheckIn({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/checkins/${id}/leave`)
        .then(() => {
          commit(mutationType.DELETE_CHECKIN, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  addTalkingPoint({}, request) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(
          `/api/checkins/${request.definitionId}/talkingpoints`,
          request.talkingPoint
        )
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveTalkingPoint({ commit, state }, talkingPoint) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(
          `/api/checkins/${state.checkin.definitionId}/talkingpoints`,
          talkingPoint
        )
        .then(res => {
          commit(mutationType.SET_CHECKIN_TALKINGPOINT, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  completeTalkingPoint({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `/api/checkins/${state.checkin.definitionId}/talkingpoints/${id}/complete`
        )
        .then(() => {
          commit(mutationType.COMPLETE_CHECKIN_TALKINGPOINT, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  unCompleteTalkingPoint({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `/api/checkins/${state.checkin.definitionId}/talkingpoints/${id}/uncomplete`
        )
        .then(() => {
          commit(mutationType.UNCOMPLETE_CHECKIN_TALKINGPOINT, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  snoozeTalkingPoint({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `/api/checkins/${state.checkin.definitionId}/talkingpoints/${id}/snooze`
        )
        .then(() => {
          commit(mutationType.SNOOZE_CHECKIN_TALKINGPOINT, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteTalkingPoint({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(
          `/api/checkins/${state.checkin.definitionId}/talkingpoints/${id}`
        )
        .then(() => {
          commit(mutationType.DELETE_CHECKIN_TALKINGPOINT, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveTalkingPointNote({ commit, state }, note) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(
          `/api/checkins/${state.checkin.definitionId}/talkingpoints/${note.parentId}/notes`,
          note
        )
        .then(res => {
          commit(mutationType.SET_CHECKIN_TALKINGPOINT_NOTE, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteTalkingPointNote({ commit, state }, note) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(
          `/api/checkins/${state.checkin.definitionId}/talkingpoints/${note.parentId}/notes/${note.id}`
        )
        .then(() => {
          commit(mutationType.DELETE_CHECKIN_TALKINGPOINT_NOTE, note);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveActionItem({ commit, state }, actionItem) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(
          `/api/checkins/${state.checkin.definitionId}/actionitems`,
          actionItem
        )
        .then(res => {
          commit(mutationType.SET_CHECKIN_ACTIONITEM, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteActionItem({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/checkins/${state.checkin.definitionId}/actionitems/${id}`)
        .then(() => {
          commit(mutationType.DELETE_CHECKIN_ACTIONITEM, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  reopenActionItem({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `/api/checkins/${state.checkin.definitionId}/actionitems/${id}/reopen`
        )
        .then(() => {
          commit(mutationType.REOPEN_CHECKIN_ACTIONITEM, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  completeActionItem({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `/api/checkins/${state.checkin.definitionId}/actionitems/${id}/complete`
        )
        .then(() => {
          commit(mutationType.COMPLETE_CHECKIN_ACTIONITEM, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveActionItemNote({ commit }, note) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/actionitems/${note.parentId}/notes`, note)
        .then(res => {
          commit(mutationType.SET_ACTION_ITEM_NOTE, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteActionItemNote({ commit }, note) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/actionitems/${note.parentId}/notes/${note.id}`)
        .then(() => {
          commit(mutationType.DELETE_ACTION_ITEM_NOTE, note);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  setDrawer({ commit }, val) {
    return new Promise(resolve => {
      commit(mutationType.SET_CHECKIN_DRAWER, val);
      resolve();
    });
  },
  setTab({ commit }, tab) {
    return new Promise(resolve => {
      commit(mutationType.SET_CHECKIN_TAB, tab);
      resolve();
    });
  },
  getOutstandingActionItems({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/actionitems", filter)
        .then(res => {
          commit(mutationType.SET_ACTION_ITEMS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  reopenOutstandingActionItem({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/actionitems/${id}/reopen`)
        .then(() => {
          commit(mutationType.REOPEN_ACTIONITEM, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  completeOutstandingActionItem({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/actionitems/${id}/complete`)
        .then(() => {
          commit(mutationType.COMPLETE_ACTIONITEM, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getUnfinishedCheckIns({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/checkins/unfinished`)
        .then(res => {
          commit(mutationType.SET_UNFINISHED_CHECKINS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getTalkingPoint({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/talkingpoints/${id}`)
        .then(res => {
          commit(mutationType.SET_TALKING_POINT, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_CHECKINS](state, overview) {
    state.overview = overview;
  },
  [mutationType.SET_CHECKIN](state, item) {
    state.checkin = item;
  },
  [mutationType.SET_CHECKIN_HISTORY](state, list) {
    state.history = list;
  },
  [mutationType.SET_CHECKIN_TAB](state, tab) {
    state.tab = tab;
  },
  [mutationType.SET_CHECKIN_TALKINGPOINT](state, talkingPoint) {
    let index = state.checkin.talkingPoints.findIndex(
      cv => cv.id == talkingPoint.id
    );
    if (index >= 0) {
      state.checkin.talkingPoints[index] = Object.assign(
        state.checkin.talkingPoints[index],
        talkingPoint
      );
    } else {
      state.checkin.talkingPoints.push(talkingPoint);
    }
  },
  [mutationType.COMPLETE_CHECKIN_TALKINGPOINT](state, talkingPointId) {
    let index = state.checkin.talkingPoints.findIndex(
      cv => cv.id == talkingPointId
    );
    if (index >= 0) {
      this._vm.$set(
        state.checkin.talkingPoints[index],
        "completeDate",
        moment()
      );
    }
  },
  [mutationType.UNCOMPLETE_CHECKIN_TALKINGPOINT](state, talkingPointId) {
    let index = state.checkin.talkingPoints.findIndex(
      cv => cv.id == talkingPointId
    );
    if (index >= 0) {
      this._vm.$set(state.checkin.talkingPoints[index], "completeDate", null);
    }
  },
  [mutationType.SNOOZE_CHECKIN_TALKINGPOINT](state, talkingPointId) {
    let index = state.checkin.talkingPoints.findIndex(
      cv => cv.id == talkingPointId
    );
    if (index >= 0) {
      this._vm.$set(state.checkin.talkingPoints[index], "snoozed", true);
    }
  },
  [mutationType.DELETE_CHECKIN_TALKINGPOINT](state, id) {
    let index = state.checkin.talkingPoints.findIndex(cv => cv.id == id);
    state.checkin.talkingPoints.splice(index, 1);
  },
  [mutationType.SET_CHECKIN_TALKINGPOINT_NOTE](state, note) {
    let tpIndex = state.checkin.talkingPoints.findIndex(
      cv => cv.id == note.parentId
    );
    if (tpIndex >= 0) {
      let noteIndex = state.checkin.talkingPoints[tpIndex].notes.findIndex(
        cv => cv.id == note.id
      );
      if (noteIndex >= 0) {
        state.checkin.talkingPoints[tpIndex].notes[noteIndex] = Object.assign(
          state.checkin.talkingPoints[tpIndex].notes[noteIndex],
          note
        );
      } else {
        state.checkin.talkingPoints[tpIndex].notes.push(note);
      }
    }
  },
  [mutationType.DELETE_CHECKIN_TALKINGPOINT_NOTE](state, note) {
    let tpIndex = state.checkin.talkingPoints.findIndex(
      cv => cv.id == note.parentId
    );
    if (tpIndex >= 0) {
      let noteIndex = state.checkin.talkingPoints[tpIndex].notes.findIndex(
        cv => cv.id == note.id
      );
      if (noteIndex >= 0) {
        state.checkin.talkingPoints[tpIndex].notes.splice(noteIndex, 1);
      }
    }
  },
  [mutationType.SET_CHECKIN_ACTIONITEM](state, actionItem) {
    let index = state.checkin.actionItems.findIndex(
      cv => cv.id == actionItem.id
    );
    let pastIndex = state.checkin.pastActionItems.findIndex(
      cv => cv.id == actionItem.id
    );
    if (index >= 0) {
      state.checkin.actionItems[index] = Object.assign(
        state.checkin.actionItems[index],
        actionItem
      );
    } else if (pastIndex >= 0) {
      state.checkin.pastActionItems[pastIndex] = Object.assign(
        state.checkin.pastActionItems[pastIndex],
        actionItem
      );
    } else {
      state.checkin.actionItems.push(actionItem);
    }
  },
  [mutationType.DELETE_CHECKIN_ACTIONITEM](state, id) {
    let index = state.checkin.actionItems.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.checkin.actionItems.splice(index, 1);
    }
  },
  [mutationType.REOPEN_CHECKIN_ACTIONITEM](state, actionItemId) {
    let index = state.checkin.pastActionItems.findIndex(
      cv => cv.id == actionItemId
    );
    if (index >= 0) {
      this._vm.$set(state.checkin.pastActionItems[index], "completeDate", null);
    }
    index = state.checkin.actionItems.findIndex(cv => cv.id == actionItemId);
    if (index >= 0) {
      this._vm.$set(state.checkin.actionItems[index], "completeDate", null);
      this._vm.$set(state.checkin.actionItems[index], "completed", false);
    }
  },
  [mutationType.COMPLETE_CHECKIN_ACTIONITEM](state, actionItemId) {
    let index = state.checkin.pastActionItems.findIndex(
      cv => cv.id == actionItemId
    );
    if (index >= 0) {
      this._vm.$set(
        state.checkin.pastActionItems[index],
        "completeDate",
        moment()
      );
      this._vm.$set(state.checkin.pastActionItems[index], "completed", true);
    }
  },
  [mutationType.SET_CHECKIN_START](state) {
    this._vm.$set(state.checkin, "startDate", moment());
    if (state.overview.checkIns) {
      let index = state.overview.checkIns.findIndex(
        cv => cv.id == state.checkin.id
      );
      if (index >= 0) {
        this._vm.$set(state.overview.checkIns[index], "startDate", moment());
      }
    }
  },
  [mutationType.SET_CHECKIN_UNSTART](state) {
    this._vm.$set(state.checkin, "startDate", null);
    if (state.overview.checkIns) {
      let index = state.overview.checkIns.findIndex(
        cv => cv.id == state.checkin.id
      );
      if (index >= 0) {
        this._vm.$set(state.overview.checkIns[index], "startDate", null);
      }
    }
  },
  [mutationType.ARCHIVE_CHECKIN](state, id) {
    if (state.checkin.definitionId == id) {
      this._vm.$set(state.checkin, "archiveDate", moment());
    }
    if (state.overview.checkIns) {
      let index = state.overview.checkIns.findIndex(
        cv => cv.definitionId == id
      );
      if (index >= 0) {
        this._vm.$set(state.overview.checkIns[index], "archiveDate", moment());
      }
    }
  },
  [mutationType.DELETE_CHECKIN](state, id) {
    if (state.checkin.definitionId == id) {
      state.checkin = {};
    }
    if (state.overview.checkIns) {
      let index = state.overview.checkIns.findIndex(
        cv => cv.definitionId == id
      );
      if (index >= 0) {
        state.overview.checkIns.splice(index, 1);
      }
    }
  },
  [mutationType.SET_CHECKIN_DRAWER](state, show) {
    state.drawer = show;
  },
  [mutationType.SET_ACTION_ITEMS](state, list) {
    state.outstanding_action_items = list;
  },
  [mutationType.REOPEN_ACTIONITEM](state, actionItemId) {
    let index = state.outstanding_action_items.findIndex(
      cv => cv.id == actionItemId
    );
    if (index >= 0) {
      this._vm.$set(
        state.outstanding_action_items[index],
        "completeDate",
        null
      );
      this._vm.$set(state.outstanding_action_items[index], "completed", false);
    }
  },
  [mutationType.COMPLETE_ACTIONITEM](state, actionItemId) {
    let index = state.outstanding_action_items.findIndex(
      cv => cv.id == actionItemId
    );
    if (index >= 0) {
      this._vm.$set(
        state.outstanding_action_items[index],
        "completeDate",
        moment()
      );
      this._vm.$set(state.outstanding_action_items[index], "completed", true);
    }
  },
  [mutationType.SET_ACTION_ITEM_NOTE](state, note) {
    let index = (state.checkin.actionItems || []).findIndex(
      cv => cv.id == note.parentId
    );
    let index2 = (state.checkin.pastActionItems || []).findIndex(
      cv => cv.id == note.parentId
    );
    let index3 = state.outstanding_action_items.findIndex(
      cv => cv.id == note.parentId
    );
    saveActionItemNote(index, state.checkin.actionItems, note);
    saveActionItemNote(index2, state.checkin.pastActionItems, note);
    saveActionItemNote(index3, state.outstanding_action_items, note);
  },
  [mutationType.DELETE_ACTION_ITEM_NOTE](state, note) {
    let index = (state.checkin.actionItems || []).findIndex(
      cv => cv.id == note.parentId
    );
    let index2 = (state.checkin.pastActionItems || []).findIndex(
      cv => cv.id == note.parentId
    );
    let index3 = state.outstanding_action_items.findIndex(
      cv => cv.id == note.parentId
    );
    deleteActionItemNote(index, state.checkin.actionItems, note);
    deleteActionItemNote(index2, state.checkin.pastActionItems, note);
    deleteActionItemNote(index3, state.outstanding_action_items, note);
  },
  [mutationType.SET_UNFINISHED_CHECKINS](state, list) {
    state.unfinished = list;
  },
  [mutationType.SET_CHECKIN_REVIEW_ANSWER](state, review) {
    let index = ((state.checkin || {}).reviews || []).findIndex(
      x => x.id == review.id
    );
    if (index >= 0) {
      state.checkin.reviews[index].answer = review.answer;
      state.checkin.reviews[index].answerText = review.answerText;
      state.checkin.reviews[index].completeDate = moment();
    }
  },
  [mutationType.SET_CHECKIN_REVIEW_FEEDBACK](state, review) {
    let index = ((state.checkin || {}).reviews || []).findIndex(
      x => x.id == review.id
    );
    if (index >= 0) {
      state.checkin.reviews[index].feedback = review.feedback;
    }
  },
  [mutationType.SET_TALKING_POINT](state, item) {
    state.talking_point = item;
  }
};

function saveActionItemNote(index, actionItems, note) {
  if (index >= 0) {
    let noteIndex = actionItems[index].notes.findIndex(cv => cv.id == note.id);
    if (noteIndex >= 0) {
      actionItems[index].notes[noteIndex] = Object.assign(
        actionItems[index].notes[noteIndex],
        note
      );
    } else {
      actionItems[index].notes.push(note);
    }
  }
}

function deleteActionItemNote(index, actionItems, note) {
  if (index >= 0) {
    let noteIndex = actionItems[index].notes.findIndex(cv => cv.id == note.id);
    if (noteIndex >= 0) {
      actionItems[index].notes.splice(noteIndex, 1);
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
